import React, { useEffect, useState } from 'react';
// import { ReportOrder } from './report-order';
// import { ReportOrderVendor } from './report-order-by-vendor';
// import { ReportFuel } from './report-fuel-by-vendor';
// import { ReportOrderCustomer } from './report-order-by-customer';

// import { Selection } from '~components';

import { SelectionForHome } from './selection-for-home';
import ApiServices from '~services';
// import {
//   // Spin,
//   Row,
//   Col,
//   Card,
//   Divider,
//   Space,
//   Button,
//   Badge,
//   Tooltip,
//   Statistic,
// } from 'antd';
// import { LoadingOutlined } from '@ant-design/icons';
// import { VehicleReplacement } from './vehicle-replacement';
// import backgroundNotPermissionImage from '~assets/images/background_not_permission.jpg';

import {
  CarOutlined,
  ToolOutlined,
  FileProtectOutlined,
  AppstoreOutlined,
} from '@ant-design/icons';

import SummaryCard from './component/summary-card';
import OrderCard from './component/order-card';
import InspectionCard from './component/inspection-card';
import TrailerCard from './component/trailer-card';
import MaintenanceCard from './component/maintenace-card';

import './index.css';

const RELOAD_TIME = 120 * 1000; //giây
const RELOAD_ON = true;

export const Home = () => {
  const [reportRomooc, setReportRomooc] = useState([]);
  const [reportOrder, setReportOrder] = useState([]);
  const [reportFuel, setReportFuel] = useState([]);
  const [reportOrderByVendor, setReportOrderByVendor] = useState([]);
  const [reportOrderCustomer, setReportOrderCustomer] = useState([]);
  const [reportDrivingLicenseList, setReportDrivingLicenseList] = useState({});
  const [vendors, setVendor] = useState([]);
  const [loading, setLoading] = useState(false);
  console.log({
    reportOrder,
    reportFuel,
    reportOrderByVendor,
    reportOrderCustomer,
    loading,
  });
  const [romoocRegister, setRomoocRegister] = useState([]);
  const [arrIdSelectVendor, setArrIdSelectVendor] = useState([]);
  const [vehicleRegister, setVehicleRegister] = useState([]);
  const [hasPermissionReport, setHasPermissionReport] = useState(true);
  const [reportCar, setReportCar] = useState({
    TotalCar: 0,
    EmptyCar: 0,
    BusyCar: 0,
  });
  const [loadingCountOrders, setLoadingCountOrders] = useState(false);
  const [countOrders, setCountOrders] = useState(null);

  const [vehicleRegistrationCounterRomooc, setVehicleRegistrationCounterRomooc] = useState({
    total: 0,
    expire: 0,
  });
  const [vehicleRegistrationCounterCar, setVehicleRegistrationCounterRomoocCar] = useState({
    total: 0,
    expire: 0,
  });
  const [vehicleRegistrationCounterLicense, setVehicleRegistrationCounterRomoocLicense] = useState({
    total: 0,
    expire: 0,
  });

  const [maintenanceCounter, setMaintenanceCounter] = useState({
    warning: 0,
    total: 0,
  });

  // ====== Count Orders from ONP, WMS ======
  const getCountAllOrdersFromOnpWms = async () => {
    if (loadingCountOrders) return;

    setLoadingCountOrders(true);
    ApiServices.getCountAllOrdersFromOnpWms()
      .then((res) => {
        console.log({ res });
        if (res?.data?.data) {
          setCountOrders(res?.data?.data);
        }
      })
      .catch((err) => {
        console.error('Get count All orders from ONP or WMS', err);
      })
      .finally(() => setLoadingCountOrders(false));
  };
  useEffect(() => {
    getCountAllOrdersFromOnpWms();
  }, []);
  useEffect(() => {
    const handleReload = setInterval(() => {
      RELOAD_ON && getCountAllOrdersFromOnpWms();
    }, RELOAD_TIME);

    return () => clearInterval(handleReload);
  }, []);

  const getReportRomooc = async () => {
    if (!hasPermissionReport) return;
    try {
      const data = await ApiServices.reportRomooc();
      if (data?.data) {
        setReportRomooc(data?.data?.[0] || []);
      } else {
        setHasPermissionReport(false);
      }
    } catch (error) {
      console.log('getReportRomooc error:', error);
      setHasPermissionReport(false);
    }
  };

  const handleReportOrder = async (value) => {
    if (!hasPermissionReport) return;

    try {
      const data = await ApiServices.reportOrder(value);
      if (data?.data) {
        setReportOrder(data?.data || []);
      } else {
        setHasPermissionReport(false);
      }
    } catch (error) {
      console.log('reportOrder error:', error);
      setHasPermissionReport(false);
    }
  };
  const getReportOrderByVendor = async (value) => {
    if (!hasPermissionReport) return;

    try {
      const { data, status } = await ApiServices.reportOrderByVendor(value);
      if (status === 200) {
        setReportOrderByVendor(data || []);
      }
    } catch (error) {
      console.log('getReportOrderByVendor error:', error);
      setHasPermissionReport(false);
    }
  };
  const getReportFuel = async (value) => {
    if (!hasPermissionReport) return;

    try {
      const data = await ApiServices.reportFuelByVendor(value);
      if (data?.data) {
        setReportFuel(data.data);
      } else {
        setHasPermissionReport(false);
      }
    } catch (error) {
      console.log('getReportFuel error:', error);
      setHasPermissionReport(false);
    }
  };
  const getReportOrderCustomer = async (value) => {
    if (!hasPermissionReport) return;

    try {
      const data = await ApiServices.reportOrderByCustomer(value);
      if (data) {
        setReportOrderCustomer(data?.data);
      } else {
        setHasPermissionReport(false);
      }
    } catch (error) {
      console.log('getReportOrderCustomer error:', error);
      setHasPermissionReport(false);
    }
  };
  const getRPRomoocInspection = async () => {
    if (!hasPermissionReport) return;

    try {
      const data = await ApiServices.getRPRomoocInspection();
      if (data?.data) {
        const dataEnd = data?.data?.[0];

        setRomoocRegister(dataEnd || []);

        setVehicleRegistrationCounterRomooc((prev) => {
          const expire = dataEnd?.ArrHetHanDangKiem?.length || 0;
          const expire10 = dataEnd?.ArrHetHanDangKiem10?.length || 0;
          const expire20 = dataEnd?.ArrHetHanDangKiem20?.length || 0;
          const expire30 = dataEnd?.ArrHetHanDangKiem30?.length || 0;

          prev.total = expire + expire10 + expire20 + expire30;
          prev.expire = expire;
          return prev;
        });
      } else {
        setHasPermissionReport(false);
      }
    } catch (error) {
      console.log('getRPRomoocInspection error:', error);
      setHasPermissionReport(false);
    }
  };

  const getReportDrivingLicense = async () => {
    try {
      const data = await ApiServices.getReportDrivingLicense();
      if (data?.data?.data) {
        const dataEnd = data?.data?.data || [];
        setReportDrivingLicenseList(dataEnd);

        setVehicleRegistrationCounterRomoocLicense((prev) => {
          const expire = dataEnd?.HetHan?.length || 0;
          const expire10 = dataEnd?.HetHan10?.length || 0;
          const expire20 = dataEnd?.HetHan20?.length || 0;

          prev.total = expire + expire10 + expire20;
          prev.expire = expire;
          return prev;
        });
      }
    } catch (error) {
      console.log('get Report Driving License error:', error);
      setHasPermissionReport(false);
    }
  };

  const initData = async (value = []) => {
    if (!hasPermissionReport) {
      setHasPermissionReport(true);
    }

    await getReportRomooc();
    await handleReportOrder(value);
    await getReportOrderByVendor(value);
    await getReportFuel(value);
    await getReportOrderCustomer(value);
    await getRPRomoocInspection();
    await getReportDrivingLicense();
  };
  useEffect(() => {
    setLoading(true);
    ApiServices.getVendors()
      .then((res) => {
        res.data?.data && initData(res.data?.data?.map((item) => item.id));
        setVendor(res.data?.data || []);
      })
      .catch((e) => console.error(e))
      .finally(setLoading(false));
  }, []);

  const getReportRegisterByCar = async (selectedVendorIds) => {
    setLoading(true);
    try {
      const { data } = await ApiServices.getRPVehicleInspection(selectedVendorIds);
      setVehicleRegister(data);

      setVehicleRegistrationCounterRomoocCar((prev) => {
        const expire = data?.hetHanDangKiem?.length || 0;
        const expire10 = data?.hetHanDangKiem10?.length || 0;
        const expire20 = data?.hetHanDangKiem20?.length || 0;
        const expire30 = data?.hetHanDangKiem30?.length || 0;
        const expireInsurance = data?.hetHanPhuHieu?.length || 0;
        const expireTag = data?.hetHanBaoHiem?.length || 0;

        prev.total = expire + expire10 + expire20 + expire30 + expireInsurance + expireTag;
        prev.expire = expire + expireInsurance + expireTag;
        return prev;
      });
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const reportVehicleByVendorIds = async (ids) => {
    return ApiServices.reportVehicle(ids)
      .then((res) => {
        if (res?.data) {
          const reduceData = res?.data?.reduce((calc, current) => {
            return {
              BusyCar: calc.BusyCar + current.BusyCar,
              EmptyCar: calc.EmptyCar + current.EmptyCar,
              TotalCar: calc.TotalCar + current.TotalCar,
            };
          });
          setReportCar(reduceData || { TotalCar: 0, EmptyCar: 0, BusyCar: 0 });
        }
      })
      .catch((err) => {
        console.log('Get report Vehicle by vendor failed: ', err);
      });
  };

  useEffect(() => {
    if (vendors?.length > 0) {
      const defaultVendorIds = vendors?.map((item) => item.id);
      setArrIdSelectVendor(defaultVendorIds);
    }
  }, [vendors]);
  useEffect(() => {
    if (arrIdSelectVendor?.length > 0) {
      getReportRegisterByCar(arrIdSelectVendor);
      reportVehicleByVendorIds(arrIdSelectVendor);
      initData(arrIdSelectVendor);
    }
  }, [arrIdSelectVendor]);
  const onChangeVender = async (value) => {
    let dataSelect = value;
    if (!value || value?.length < 1) {
      const defaultVendorIds = vendors?.map((item) => item.id);
      dataSelect = defaultVendorIds;
    }
    setArrIdSelectVendor(dataSelect);
  };

  return (
    <div className='container'>
      <div className='dashboard'>
        <div className='fleet-filter'>
          <div className='fleet-filter-title'>
            <CarOutlined />
            <span>Đội Xe</span>
          </div>

          <SelectionForHome
            mode='multiple'
            data={vendors}
            onSearch={false}
            // style={{ width: 188 }}
            onChange={onChangeVender}
            value={arrIdSelectVendor}
          />

          {/* <div className='fleet-tags'>
            {vehicles.map((item, index) => {
              return (
                <span className='fleet-tag' key={index}>
                  {item} <CloseOutlined />
                </span>
              );
            })}
          </div> */}
        </div>

        <div className='summary-grid'>
          <SummaryCard
            icon={<CarOutlined />}
            title='Xe'
            value={reportCar?.TotalCar || 0}
            status='Xe trống'
            statusValue={reportCar?.EmptyCar || 0}
            type='success'
            bgcIcon='green'
            contentTop='Tổng số Xe'
            colorTop='orange'
            contentBottom='Số lượng Xe đang trống'
            colorBottom='red'
          />

          <SummaryCard
            icon={<AppstoreOutlined />}
            title='Romooc'
            value={reportRomooc?.TotalRomooc || 0}
            status='Romooc trống'
            statusValue={reportRomooc?.EmptyRomooc || 0}
            type='success'
            bgcIcon='green'
            contentTop='Tổng số Romooc'
            colorTop='orange'
            contentBottom='Số lượng Romooc đang trống'
            colorBottom='red'
          />

          <SummaryCard
            icon={<FileProtectOutlined />}
            title='Hạn Đ.Kiểm'
            value={
              vehicleRegistrationCounterRomooc?.total +
                vehicleRegistrationCounterCar?.total +
                vehicleRegistrationCounterLicense?.total || 0
            }
            status='Đã hết hạn'
            statusValue={
              vehicleRegistrationCounterRomooc?.expire +
                vehicleRegistrationCounterCar?.expire +
                vehicleRegistrationCounterLicense?.expire || 0
            }
            type='danger'
            bgcIcon='orange'
            contentTop='Tổng số lượng của các cảnh báo về Hạn đăng kiểm: (Hạn Đăng Kiểm Xe + Giấy Phép Lái Xe + Hạn Đăng Kiểm Romooc)'
            colorTop='orange'
            contentBottom='Tổng số lượng đăng kiểm với cảnh báo Đã hết hạn của: (Hạn Đăng Kiểm Xe + Giấy Phép Lái Xe + Hạn Đăng Kiểm Romooc)'
            colorBottom='red'
          />

          <SummaryCard
            icon={<ToolOutlined />}
            title='C.Báo Bảo Trì'
            value={maintenanceCounter.warning || 0}
            status='Số lượng'
            statusValue={maintenanceCounter.total || 0}
            type='danger'
            bgcIcon='orange'
            contentTop='Tổng số cảnh báo của Bảo trì sửa chũa)'
            colorTop='orange'
            contentBottom='Tổng số lượng của các cảnh báo Bảo trì sửa chũa'
            colorBottom='red'
          />
        </div>
        <div className='content-grid'>
          <OrderCard data={countOrders} />
          <InspectionCard
            vehicleRegister={vehicleRegister}
            arrIdSelectVendor={arrIdSelectVendor}
            reportDrivingLicenseList={reportDrivingLicenseList}
          />
          <TrailerCard data={romoocRegister} />
          <MaintenanceCard
            arrIdSelectVendor={arrIdSelectVendor}
            setMaintenanceCounter={setMaintenanceCounter}
          />
        </div>
      </div>
    </div>
  );
};
